import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { Button, Icon, Input } from "../../components/ui";
import { authService } from "../../services/auth";

export default function Forgot() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await authService.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    <AuthLayout title="ลืมรหัสผ่าน" subtitle="กรอกอีเมลที่ใช้สมัคร เราจะส่งลิงก์ตั้งรหัสผ่านใหม่ให้" footer={<Link to="/login">กลับไปหน้าเข้าสู่ระบบ</Link>}>
      {sent ? (
        <div className="auth-sent">
          <span className="pay-check"><Icon name="mail" size={28} /></span>
          <b>ส่งลิงก์แล้ว</b>
          <p className="small muted">ตรวจสอบกล่องจดหมายของ {email} (รวมถึงโฟลเดอร์สแปม)</p>
        </div>
      ) : (
        <form onSubmit={submit} noValidate className="auth-form">
          <Input label="อีเมล" type="email" icon="mail" placeholder="you@example.com" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
          {error ? <div className="form-error" role="alert">{error}</div> : null}
          <Button type="submit" variant="primary" block size="lg" loading={loading}>ส่งลิงก์ตั้งรหัสผ่านใหม่</Button>
        </form>
      )}
    </AuthLayout>
  );
}
